import React from 'react';
import PropTypes from 'prop-types';
import { Container, Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import './SchedulEditPanel.scss';

const SchedulEditPanel = ({
    saveScheduleEdit, cancelScheduleEdit, eligbleForScheduleEditSave, eligbleForScheduleEditCancel
}) => {
    return (
        <Container fluid>
            <Button
                floated="left"
                icon
                labelPosition='left'
                primary
                size='small'
                disabled={!eligbleForScheduleEditSave()}
                onClick={saveScheduleEdit}>
                <Icon name='save' />
                {i18next.t('save')}
            </Button>
            <Button
                floated="left"
                icon
                labelPosition='left'
                secondary
                size='small'
                disabled={!eligbleForScheduleEditCancel()}
                onClick={(event) => cancelScheduleEdit()}>
                <Icon name='cancel' />
                {i18next.t('cancel')}
            </Button>
        </Container>
    );
};

SchedulEditPanel.propTypes = {
    saveScheduleEdit: PropTypes.func,
    cancelScheduleEdit: PropTypes.func,
    eligbleForScheduleEditSave: PropTypes.func,
    eligbleForScheduleEditCancel: PropTypes.func,
    
};

export default SchedulEditPanel;